'use strict';

import { BaseController } from '../../../../base/controller';

export class ContractingPartnersController extends BaseController {
  constructor($rootScope, controllerService, cardService, uiModalDeclarationService) {
    'ngInject';
    super({ $rootScope, controllerService, cardService, uiModalDeclarationService });
  }

  get contractingPartners() {
    return this.cardService.contractingPartners;
  }

  get selectedContractingPartner() {
    return this.selected && this.getNameOfContractingPartner(this.selected);
  }

  $onInit() {
    this.$rootScope.$on('newContractingPartners', (event, partner) => {
      if (this.selected && this.selected.id === partner.id) {
        this.selectContractingPartner(null, partner);
      }
    });
  }

  selectedTrash() {
    this.cardService.contractingPartners.splice(
      this.contractingPartners.map((e) => { return e.id; }).indexOf(this.selected.id), 1);
    this.selected = null;
  }

  getNameOfContractingPartner(cp) {
    return `${cp.firstName} ${cp.lastName}`;
  }

  newContractingPartner() {
    this.uiModalDeclarationService.open('contractingPartners').then(partner => {
      this.selectContractingPartner(null, partner);
    });
  }

  editContractingPartner($event, contractingPartner) {
    this.stopEvent($event);
    this.cardService.editContractingPartner(contractingPartner);
  }

  selectContractingPartner($event, partner) {
    this.selected = partner;
    this.contractingPartnersOpen = false;
    this.onSelect({ partner });
  }

  toggleContractingPartnersDropDown($event) {
    this.stopEvent($event);
    if (!this.contractingPartners.length) {
      return this.newContractingPartner();
    }
    this.contractingPartnersOpen = !this.contractingPartnersOpen;
  }

  stopEvent($event) {
    if ($event) {
      $event.stopPropagation();
      $event.preventDefault();
    }
  }
}
